<mp-detail-view [werte]="mieterDaten?.werte?.warmwasser" [typeConfig]="typeConfig"></mp-detail-view>
